(() => {
  const FREE_DELIVERY_THRESHOLD = 359000;
  const FREE_GIFT_THRESHOLD = 499000;
  const BLOCK_CLASS = 'solea-aov';
  let refreshTimer;
  let refreshing = false;

  const formatIDR = (amount) => `Rp ${Math.max(0, Math.round(amount)).toLocaleString('id-ID')}`;

  const getDrawer = () => document.querySelector('cart-drawer');

  const getFooter = () =>
    document.querySelector('#CartDrawer .drawer__footer') ||
    document.querySelector('cart-drawer .drawer__footer');

  const closeDrawer = () => {
    const drawer = getDrawer();
    const closeButton = drawer?.querySelector('.drawer__close');

    if (closeButton) closeButton.click();

    window.setTimeout(() => {
      const productGrid =
        document.querySelector('[id*="featured_collection"] .product-grid') ||
        document.querySelector('#ProductGridContainer') ||
        document.querySelector('.product-grid');

      if (productGrid) {
        productGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.location.assign('/collections/frontpage?build=your-set');
      }
    }, 180);
  };

  const render = (cart) => {
    const footer = getFooter();
    const checkout = footer?.querySelector('.cart__ctas');
    if (!footer || !checkout || !cart?.item_count) return;

    const total = Number(cart.total_price || 0) / 100;
    const remaining = Math.max(0, FREE_GIFT_THRESHOLD - total);
    const progress = Math.min(100, Math.max(4, (total / FREE_GIFT_THRESHOLD) * 100));
    const signature = `${cart.item_count}:${Math.round(total)}`;
    const existing = footer.querySelector(`.${BLOCK_CLASS}`);

    if (existing?.dataset.signature === signature) return;

    const setTitle = total >= FREE_DELIVERY_THRESHOLD
      ? 'YOU GOT FREE DELIVERY'
      : cart.item_count >= 2
        ? 'YOUR SET IS READY'
        : 'BUILD YOUR OWN SET';
    const setMessage = cart.item_count >= 2
      ? `${cart.item_count} favorites selected. Every item keeps its own size and color.`
      : 'Choose one more favorite. Each item keeps its own size and color.';
    const giftMessage = remaining > 0
      ? `Add ${formatIDR(remaining)} to unlock your FREE GIFT.`
      : 'FREE GIFT UNLOCKED.';
    const buttonText = cart.item_count >= 2 ? 'ADD ONE MORE FAVORITE' : 'ADD ANOTHER FAVORITE';

    const block = document.createElement('div');
    block.className = BLOCK_CLASS;
    block.dataset.signature = signature;
    block.setAttribute('aria-live', 'polite');
    block.innerHTML = `
      <p class="solea-aov__eyebrow">${setTitle}</p>
      <p class="solea-aov__message">${setMessage}</p>
      <div class="solea-aov__track" role="progressbar" aria-label="Free gift progress" aria-valuemin="0" aria-valuemax="${FREE_GIFT_THRESHOLD}" aria-valuenow="${Math.min(FREE_GIFT_THRESHOLD, Math.round(total))}">
        <span class="solea-aov__bar" style="transform: scaleX(${progress / 100})"></span>
      </div>
      <p class="solea-aov__gift">${giftMessage}</p>
      <button type="button" class="solea-aov__continue">${buttonText}</button>
    `;

    block.querySelector('.solea-aov__continue')?.addEventListener('click', closeDrawer);
    existing?.remove();
    footer.insertBefore(block, checkout);
  };

  const refresh = async () => {
    const drawer = getDrawer();
    if (!drawer || refreshing || !drawer.classList.contains('active')) return;

    refreshing = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;
      render(await response.json());
    } catch (error) {
      console.warn('[Solea AOV] Cart enhancement unavailable.', error);
    } finally {
      refreshing = false;
    }
  };

  const scheduleRefresh = () => {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 120);
  };

  document.addEventListener('DOMContentLoaded', () => {
    const drawer = getDrawer();
    if (!drawer) return;

    new MutationObserver(scheduleRefresh).observe(drawer, {
      attributes: true,
      attributeFilter: ['class'],
      childList: true,
      subtree: true,
    });

    scheduleRefresh();
  });
})();
